import { createFileRoute } from '@tanstack/react-router';
import { ConversationInbox } from '@/features/meta-omnichannel/components/ConversationInbox';
import { NewConversationDialog } from '@/features/meta-omnichannel/components/NewConversationDialog';

export const Route = createFileRoute('/_authenticated/meta-omnichannel')({
  component: MetaOmnichannelInboxPage,
});

function MetaOmnichannelInboxPage() {
  return (
    <div className="space-y-6">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold">Omnicanal — Caixa de Entrada</h1>
          <p className="text-muted-foreground mt-1">
            Mensagens do Facebook Messenger, Instagram e WhatsApp Business em um só lugar.
          </p>
        </div>
        <NewConversationDialog />
      </div>
      <ConversationInbox />
    </div>
  );
}
